/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DiscountCampaignPaginateResponse } from '../../models/discount-campaign-paginate-response';

export interface GetDiscountIndex$Params {

/**
 * Pagination offset
 */
  page?: number;

/**
 * Pagination limit
 */
  limit?: number;

/**
 * Pagination order field ascending
 */
  orderAsc?: 'id' | 'label' | 'value' | 'type' | 'active';

/**
 * Pagination order field descending
 */
  orderDesc?: 'id' | 'label' | 'value' | 'type' | 'active';

/**
 * Filter DiscountCampaign id
 */
  id?: number;

/**
 * Filter by camp id
 */
  camp?: number;
}

export function getDiscountIndex(http: HttpClient, rootUrl: string, params?: GetDiscountIndex$Params, context?: HttpContext): Observable<StrictHttpResponse<DiscountCampaignPaginateResponse>> {
  const rb = new RequestBuilder(rootUrl, getDiscountIndex.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('orderAsc', params.orderAsc, {});
    rb.query('orderDesc', params.orderDesc, {});
    rb.query('id', params.id, {});
    rb.query('camp', params.camp, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DiscountCampaignPaginateResponse>;
    })
  );
}

getDiscountIndex.PATH = '/v1/discount';
